import { App } from 'antd';
import Icon from '../../cpn/Icon';
import {  useKaipiaodanDelMutation } from '../../store/DianShangYeWuApi';   
function InvoiceDel(props) {
    const {modal,message} = App.useApp(); 
    const [submitDel] = useKaipiaodanDelMutation()  
    return (
        <Icon type='delete'  onClick={() => {
            if (!props.kpsq_id) {
                message.error('缺少必要的ID参数');
                return;
            }
            modal.confirm({
                title: '点击确定删除开票申请',
                content: '删除后不能恢复！',
                okText: '确认',
                okType: 'danger',
                cancelText: '取消',
                onOk() {
                    submitDel({
                        kpsq_id:props.kpsq_id+'',
                    }).then((res) => {
                        // console.log(res);
                        if (res.data.Status === 'success') {
                            message.info('删除成功！');
                        }
                        if (res.data.Status === "fail") {
                            message.error('删除失败！'+res.data.Message)
                        }
                    })
                },
                onCancel() {
                    // console.log('Cancel');
                },
            }); 
        }}/>
    )
}

export default InvoiceDel